// ─── Assignment Status Options ────────────────────────────────────────────────
export const ASSIGNMENT_STATUS_OPTIONS = [
  "New Order Assigned",
  "Assignment Accepted Fully",
  "Assignment Partially Accepted",
  "Assignment Rejected",
  "Packed - Ready to Dispatch",
  "Dispatched",
];

// ─── Assignment Acceptance Dropdown ───────────────────────────────────────────
export const ASSIGNMENT_ACCEPTANCE_OPTIONS = [
  { label: "Accept Assignment Fully", value: "Assignment Accepted Fully" },
  { label: "Accept Assignment Partially", value: "Assignment Partially Accepted" },
  { label: "Reject Assignment", value: "Assignment Rejected" },
  { label: "Packed - Ready to Dispatch", value: "Packed - Ready to Dispatch" },
];

// ─── Product Acceptance Status Options ────────────────────────────────────────
export const PRODUCT_ACCEPTANCE_STATUS_OPTIONS = [
  { label: "Product Assigned", value: "Product Assigned" },
  { label: "Product Available", value: "Product Available" },
  { label: "Partially Available", value: "Partially Available" },
  { label: "Product Not Available", value: "Product Not Available" },
  { label: "Raw Material Needed", value: "Raw Material Needed" },
];

// ─── Order Status Remark Templates ────────────────────────────────────────────
export const ORDER_STATUS_REMARK_MAP = {
  "Assignment Accepted Fully": (assignedTo) =>
    `Assignment Accepted Fully by ${assignedTo}`,
  "Assignment Partially Accepted": (assignedTo) =>
    `Assignment Partially Accepted by ${assignedTo}`,
  "Assignment Rejected": (assignedTo) =>
    `Assignment Rejected by ${assignedTo}`,
  "Packed - Ready to Dispatch": (assignedTo) =>
    `Packed - Ready to Dispatch by ${assignedTo}`,
};

// ─── Firebase Collection Names ─────────────────────────────────────────────────
export const COLLECTIONS = {
  ASSIGNMENTS: "assignments",
  ORDERS: "orders",
};

// ─── Route Paths ──────────────────────────────────────────────────────────────
export const ROUTES = {
  WAREHOUSE_POV: "/assigned/warehouse-pov",
  WAREHOUSE_ASSIGNMENT: (id) => `/assigned/warehouse-pov/${id}`,
};
